import { Shape } from './Shape.js';
import { fabric } from 'fabric';
import { ShapeAction } from './ShapeFactory.js';
//const fabric = window.fabric;

const COMMENT_PATH = 'M251.8208033166431 279.9114505865103H47.9042603841031C26.5839180952476 279.9114505865103 9.2375366568915 262.5515489736071 9.2375366568915 241.2069281524927V116.2922700879766C9.2375366568915 94.9957614369502 26.5083870919699 77.6633524926687 47.7669312872345 77.5877472140763V20.9030195014663L129.1498710348879 77.5877472140763H251.8208033166431C273.1411456054986 77.5877472140763 290.4875270438547 94.9510860703813 290.4875270438547 116.2922700879766V241.2069281524927C290.4875270438547 262.5515489736071 273.1411456054986 279.9114505865103 251.8208033166431 279.9114505865103zM274.0080354196186 116.2922700879765C274.0080354196186 104.0477225806451 264.0551089043378 94.0833483870968 251.8208033166431 94.0833483870968H123.9794300983307L64.2464229114706 52.4766312316716V94.0833483870968H47.9042603841031C35.6699547964084 94.0833483870968 25.7170282811276 104.0477225806452 25.7170282811276 116.2922700879765V241.2069281524927C25.7170282811276 253.4549120234604 35.6699547964084 263.4158494134897 47.9042603841031 263.4158494134897H251.8208033166431C264.0551089043377 263.4158494134897 274.0080354196185 253.4549120234604 274.0080354196185 241.2069281524927zM274.0080354196186 116.2922700879765M84.5127646015858 221.6252749266862H215.2122990991604V205.1296737536657H84.5127646015859zM84.5127646015858 221.6252749266862M84.5127646015858 186.4346590909091H215.2122990991604V169.9390579178886H84.5127646015859zM84.5127646015858 186.4346590909091M84.5127646015858 151.244043255132H215.2122990991604V134.7484420821115H84.5127646015859zM84.5127646015858 151.244043255132';
var defaultProps = {
    top: 30,
    left: 30,
    scaleX: .2,
    scaleY: .2
};
class CommentStamp extends Shape {
    constructor(props) {
        super(props);
        this.fabricImage = null;
        this.origX = 0;
        this.origY = 0;
    }
    draw(props) {
        let _this = this;
        this.newProps = {
            ...defaultProps,
            ...props        
        };

        if (this.newProps.tintColor !== '' && this.newProps.tintColor !== undefined){
            this.newProps.fill = this.newProps.tintColor;
        }
        
        let canvasObject = new fabric.Path(COMMENT_PATH, {
            ..._this.newProps, flipY : true
        });
        super.toFebricObject(canvasObject);
        canvasObject.uuid = _this.newProps.uuid;
        canvasObject.uuid_parent = _this.newProps.uuid_parent;
        _this.newProps.action = ShapeAction.ADD;
               
        // if (this.newProps.tintColor !== '' && this.newProps.tintColor !== undefined){
        //     var filter = new fabric.Image.filters.BlendColor({
        //         color: this.newProps.tintColor,
        //         mode: 'tint',            
        //       });
        //     canvasObject.filters.push(filter);
        //     canvasObject.applyFilters();
        // }

        if (this.newProps.tintColor !== '' && this.newProps.tintColor !== undefined){
            this.newProps.fill = this.newProps.tintColor;
        }

        super.draw(canvasObject);
        canvasObject.filters = [];


        if (_this.onDrawCompleted) {
            let imageObject = canvasObject.toObject();
            _this.onDrawCompleted({
                ..._this.newProps,
                ...imageObject
            });
        }
    }
}

export { CommentStamp };
